import(/* webpackMode: "eager", webpackExports: ["HomeHashLinks"] */ "/app/app/[locale]/(site)/components/cambodia-food-expo/ui/HomeHashLinks.tsx");
